import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';

import {
    combineClasses,
} from 'wanderu-css';

import Button from '../Button/Button';
import Typography from '../Typography/Typography';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './Card.scss';

function Title(props) {
    const {
        className,
        title,
    } = props;

    if (typeof title === 'string') {
        return (
            <Typography
                className={className}
                variant="h6"
            >
                {title}
            </Typography>
        );
    }

    return title;
}

Title.propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
};

function Body(props) {
    const {
        body,
        className,
    } = props;

    if (typeof body === 'string') {
        return (
            <Typography className={className}>
                {body}
            </Typography>
        );
    }

    return body;
}

Body.propTypes = {
    body: PropTypes.node,
    className: PropTypes.string,
};

/**
 * The Card component displays content and actions related to a given topic.
 * The component can optionally render an image, title, body,
 * and button (of the ghost variety) or link.
 */
function Card(props) {
    const {
        body,
        buttonProps,
        buttonText,
        children,
        className,
        classes: classesProp = {},
        component: ComponentProp = 'div',
        componentProps,
        elevation,
        imageComponent,
        title,
        variant = 'contained',
        ...otherProps
    } = props;

    let Component = ComponentProp;

    const classes = combineClasses(styles, classesProp);
    const isContained = variant === 'contained';
    const hasContent = !!title || !!body || !!buttonText;

    return (
        <Component
            className={clsx(
                classes.root,
                {
                    [classes.contained]: isContained,
                    [classes[`elevation${elevation}`]]: !!elevation,
                },
                className,
            )}
            {...componentProps}
            {...otherProps}
        >
            {imageComponent}
            {children}
            {hasContent && (
                <div
                    className={clsx(
                        classes.content,
                        { [classes.containedContent]: isContained },
                    )}
                >
                    {!!title && <Title className={classes.title} title={title} />}
                    {!!body && <Body body={body} className={classes.body} />}
                    {!!buttonText && (
                        <Button
                            className={classes.button}
                            variant="text"
                            {...buttonProps}
                        >
                            {buttonText}
                        </Button>
                    )}
                </div>
            )}
        </Component>
    );
}

Card.propTypes = {
    body: PropTypes.node,
    buttonProps: PropTypes.object,
    buttonText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
    children: PropTypes.node,
    classes: PropTypes.object,
    className: PropTypes.string,
    component: PropTypes.elementType,
    componentProps: PropTypes.object,
    elevation: PropTypes.number,
    imageComponent: PropTypes.node,
    role: PropTypes.string,
    title: PropTypes.node,
    variant: PropTypes.oneOf(['contained', 'floating']),
};
export {
    Body,
    Card,
    Title,
};
export default Card;
